import React, { useContext } from 'react';
import styled from 'styled-components';
import { MapContext } from 'react-mapbox-gl';

import { STYLE } from './constants';

interface ZoomControlProps {
  zoomDiff?: number;
  isMobile: boolean;
}

export const ZoomControl = (props: ZoomControlProps): JSX.Element | null => {
  const { isMobile, zoomDiff = 0.5 } = props;
  const map = useContext(MapContext);

  if (!map) return null;

  const onClickPlus = () => {
    map.zoomTo(map.getZoom() + zoomDiff);
  };

  const onClickMinus = () => {
    map.zoomTo(map.getZoom() - zoomDiff);
  };

  return (
    <Container
      $isMobile={isMobile}
      onMouseEnter={() => map.doubleClickZoom.disable()}
      onMouseLeave={() => map.doubleClickZoom.enable()}
    >
      <Button $role="zoomIn" onClick={onClickPlus} />
      <Button $role="zoomOut" onClick={onClickMinus} />
    </Container>
  );
};

const Container = styled.div<{ $isMobile: boolean }>`
  position: absolute;
  z-index: 40;
  top: 10px;
  left: 10px;
  display: flex;
  flex-direction: column;

  ${({ $isMobile }) =>
    $isMobile &&
    `
      top: 20%;
      transform: translateY(-50%);
      right: 10px;
      left: auto;
  `}
`;

const Button = styled.button<{ $role: 'zoomIn' | 'zoomOut' }>`
  position: relative;
  width: 46px;
  height: 52px;
  background: #fff;
  border: 0;
  cursor: pointer;

  ${({ $role }) =>
    $role === 'zoomIn' &&
    `
    border-top-left-radius: ${STYLE.radius}px;
    border-top-right-radius: ${STYLE.radius}px;

    ::before {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -10px;
      width: 20px;
      height: 1px;
      content: '';
      background-color: ${STYLE.color};
    }

    ::after {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -10px;
      width: 20px;
      height: 1px;
      content: '';
      background-color: ${STYLE.color};
      transform: rotate(90deg);
    }
  `}

  ${({ $role }) =>
    $role === 'zoomOut' &&
    `
      border-bottom-right-radius: ${STYLE.radius}px;
      border-bottom-left-radius: ${STYLE.radius}px;

      ::before {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -10px;
        width: 20px;
        height: 1px;
        content: '';
        background-color: ${STYLE.color};
  `}
`;
